import styled, { css } from 'styled-components';

import {
  GatorProtectDateRangeBadge,
  GatorProtectPanelTitle,
} from '../../GatorProtectHandler.styles';

export const ThreatsTableSectionHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.v3.spacing.xxxs};

    @media (min-width: ${theme.v3.breakpoints.md}) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 24px;
    }
  `}
`;

/** Mobile: top row — title + info icon on the left, circular export on the right. */
export const ThreatsTableSectionMobileTopRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.v3.spacing.nano};
    width: 100%;
    min-width: 0;
  `}
`;

export const ThreatsTableSectionMobileTitleGroup = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.v3.spacing.nano};
    min-width: 0;
    flex: 1;
  `}
`;

export const ThreatsTableSectionMobileInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ThreatsTableSectionTitle = styled(GatorProtectPanelTitle)`
  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin-bottom: 0;
    }
  `}
`;

/** Mobile section title — layout for heading + trailing info icon. */
export const ThreatsTableSectionMobileTitle = styled(ThreatsTableSectionTitle)`
  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex: 1;
      min-width: 0;
    }
  `}
`;

export const ThreatsTableSectionInfoStrip = styled(GatorProtectDateRangeBadge)`
  ${({ theme }) => css`
    box-sizing: border-box;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const ThreatsTableSectionHeaderActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;

    @media (min-width: ${theme.v3.breakpoints.md}) {
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.v3.spacing.nano};
      width: 100%;
      min-width: 0;
    }

    & > button {
      width: 100%;

      @media (min-width: ${theme.v3.breakpoints.md}) {
        width: auto;
      }
    }

    // & button > svg {
    //   fill: transparent !important;
    // }
  `}
`;

/** Vertical list of threat rows below `md` (card layout). */
export const ThreatsMobileList = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    width: 100%;
  `}
`;

/** Single threat summary on mobile — bordered card aligned with Gator Protect surfaces. */
export const ThreatsMobileCard = styled.article`
  ${() => css`
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 16px 0;
      border-bottom: 1px solid #EDF1F9;
  `}
`;

export const ThreatsMobileField = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ThreatsMobileLabel = styled.span`
  ${({ theme }) => css`
    width: fit-content;
    flex-shrink: 0;
    color: ${theme.v3.colors.neutral[30]};
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  `}
`;

export const ThreatsMobileValue = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    width: 100%;
  `}
`;

export const ActionsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: ${theme.v3.spacing.nano};

    @media (min-width: ${theme.v3.breakpoints.md}) {
      gap: ${theme.v3.spacing.xxxs};
    }
  `}
`;
